module.exports = __webpack_public_path__ + "static/sport/bgi-btn02.8458f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/bgi-btn02.png
// module id = 0r6y
// module chunks = 0